import { ref } from '@vue/composition-api';

export const useFormValidation = () => {
  const valid = ref(true);
  const form = ref<{ validate: () => boolean; resetValidation: Function }>();
  const formValidate = () => form && form.value && form.value.validate();
  const resetFormValidation = () =>
    form && form.value && form.value.resetValidation();

  return {
    valid,
    form,
    formValidate,
    resetFormValidation,
  };
};
